import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import {
  AllCheckStatus,
  CertCheckState,
  JoinTermsValue,
  MvnoCheckValue,
  PartnerListData,
  RecoilStateList,
  TelNumState,
  TelTypeState,
  uiVerifyStyle
} from 'src/recoil/common'
import {
  CustomBtn,
  JoinSubmitWrap,
  NoticeFeeText,
} from 'src/styles/styledcomponent/views/RopForm/JoinSubmit'

import PageCalling from 'src/components/common/PageCalling'
import useAPI from 'src/hooks/useAPI'
import { PartnerListType } from 'src/types/type'

const JoinSubmit = (props: any): JSX.Element => {
  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const params = useParams()
  const { submit } = props
  const api = useAPI('requestJoin')
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const ResetPhoneNum = useResetRecoilState(TelNumState)
  const ResetCertCheck = useResetRecoilState(CertCheckState)
  const ResetTelType = useResetRecoilState(TelTypeState)
  const ResetTermsAgree = useResetRecoilState(JoinTermsValue)
  const ResetTerms = useResetRecoilState(AllCheckStatus)
  const ResetMvnoCheck = useResetRecoilState(MvnoCheckValue)
  const { cashSpace, verifyBtn, cancelBtn } = useRecoilValue(uiVerifyStyle)
  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    TranID: TransId,
    Telecom: TelType,
    PNumber: PhoneNum,
    PCode: params.pcode,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData?.TermsIdx,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const isJoinApiPending = submit.isVulnerableCheckPending || isLoading
  const isJoinBusy = submit.isJoinSubmitting || isJoinApiPending

  return (
    <JoinSubmitWrap>
      <PageCalling active={isJoinApiPending} />
      <CustomBtn {...verifyBtn} onClick={() => submit.join(JoinRequest)} disabled={isJoinBusy}>
        {PartnerData.ButtonMsgAfter}
      </CustomBtn>
      <CustomBtn
        {...cancelBtn}
        onClick={() => {
          ResetPhoneNum()
          ResetCertCheck()
          ResetTerms()
          ResetTelType()
          ResetTermsAgree()
          ResetMvnoCheck()
        }}
      >
        취소
      </CustomBtn>
      <NoticeFeeText
        cashSpace={cashSpace}
        fontColor={PartnerData.FontColor}
        fontSize={PartnerData.FontSize}
        dangerouslySetInnerHTML={{ __html: PartnerData.NotiContent }}
      />
    </JoinSubmitWrap>
  )
}
export default JoinSubmit
